exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back-next-footer-container{display:flex;justify-content:space-between;width:90%;margin:0 auto;padding:30px}@media(max-width:992px){.back-next-footer-container{padding:0;width:100%;justify-content:space-evenly;bottom:10%}}.back-next-footer-container .back-next-footer-buttons{min-width:170px}@media(max-width:992px){.back-next-footer-container .back-next-footer-buttons{min-width:130px}}.back-next-footer-container .back{background-color:#9fa19e}@media(max-width:992px){.back-next-footer-container .back{background-color:transparent;color:#1e3c4d;border:1px solid #1e3c4d}}", ""]);

// exports
